import React from 'react';

export default function Brief(){
	return (
		<div className='brief'>
			<h1>Hello, I'm Dan. I'm a web developer.</h1>
			<h2>I love writing {'<'}code />, learning and experimenting with new technologies. Check out my recent <a className='anchor anchor--highlighted' href='#projects'>projects</a> and tech stack.</h2>
		</div>
	);
}